import React from 'react'
import { Box } from '@mui/material'
import { Unwrapped } from '@jsonforms/material-renderers'
import { withJsonFormsControlProps, withTranslateProps } from '@jsonforms/react'

const { MaterialEnumControl } = Unwrapped

export function CustomMaterialEnumControl(props) {
    // x-pandium-metadata-unsynced: backend sets this when no tenant run has synced metadata yet for this field
    const isUnsynced = props.schema['x-pandium-metadata-unsynced']
    const options = isUnsynced
        ? []
        : props.schema.enum?.map((option) => ({
              label: option,
              value: option,
          }))

    const isCell = props.path?.includes('.')

    return (
        <Box
            sx={{
                '& .MuiFormControl-root': {
                    minWidth: isCell ? '100%' : '225px',
                    width: isCell ? '100%' : 'auto',
                },
            }}
        >
            <MaterialEnumControl
                {...props}
                enabled={isUnsynced ? false : props.enabled}
                uischema={
                    !props.uischema.options?.trim
                        ? { ...props.uischema, options: { trim: true } }
                        : props.uischema
                }
                options={options}
            />
        </Box>
    )
}

export default withJsonFormsControlProps(
    withTranslateProps(CustomMaterialEnumControl)
)
